import api from './api';

export default {
  mixins: [api],
  data() {
    return {isLookingUpParty: false};
  },
  methods: {
    async fillPartyByINN(resource) {
      if (this.isDisabled || this.isLookingUpParty) return;

      const item = this.newItem;
      const inn = String(item.inn || '').trim();
      if (!/^(?:[0-9]{10}|[0-9]{12})$/.test(inn)) {
        this.showError('ИНН должен содержать 10 или 12 цифр.');
        return;
      }

      this.isLookingUpParty = true;
      try {
        const result = await this.post(`${resource}/lookup-inn`, {inn});
        // A response for an old form or a changed INN must not overwrite edits.
        if (this.newItem !== item || String(item.inn || '').trim() !== inn) return;
        if (result.error || !result.data) {
          this.showError(result.message || 'Не удалось получить реквизиты. Попробуйте позже.');
          return;
        }
        const party = result.data.party;
        if (!party) {
          this.showError('Данные по ИНН не найдены.');
          return;
        }
        for (const field of ['inn', 'kpp', 'ogrn', 'name', 'full_name', 'address']) {
          item[field] = party[field] || '';
        }
      } catch (error) {
        this.showError('Не удалось получить реквизиты. Проверьте соединение и попробуйте ещё раз.');
      } finally {
        this.isLookingUpParty = false;
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/network/partyLookup.js